module.exports = __webpack_public_path__ + "static/media/right-check.4b5eed42.svg";